<template>
  <div>
    <!-- v-loading="loading" :element-loading-text="loadingText" -->
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">{{ statusName }}</div>
        <el-form
          class="zj-search-form clear"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="企业名称">
            <el-input v-model="companyName" style="width: 35rem"></el-input>
          </el-form-item>
          <el-form-item label="所属单位">
            <el-select
              v-model="BelongCompanyTypeId"
              placeholder="请选择"
              style="width: 35rem"
            >
              <el-option>请选择</el-option>
              <el-option
                v-for="item in typeLevelDic"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <!-- <zj-layout-main style="padding-top:0px;" v-loading="searching" element-loading-text="搜索中"> -->
      <zj-layout-main style="padding-top: 0px">
        <zj-layout-container>
          <zj-layout-header>
            <div class="zj-button-bar">
              <el-button size="mini" @click="onAdd">添 加</el-button>
            </div>
          </zj-layout-header>
          <zj-layout-main style="padding: 0.8rem 0px 0px 0px">
            <el-table
              class="table-default"
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              height="100%"
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="Name" label="停车场名称"></el-table-column>
              <el-table-column
                prop="JsonExtend.TotalPlace"
                label="总停车位"
                align="center"
              >
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).TotalPlace
                    }}
                  </span>
                </template></el-table-column
              >
              <el-table-column
                prop="Address"
                label="地址"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="AdminName"
                label="联系人"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="AdminPhone"
                label="电话"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </zj-layout-main>
        </zj-layout-container>
      </zj-layout-main>
      <!-- 分页 -->
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "CompanyParkList",
  controller: "UI",
  action: "CompanyParkList",
  props: {
    fullPath: String,
    path: String,
    query: Object,
    hash: String,
    targetUrl: String,
    targetUri: Object,
    menu: Object,
  },
  data() {
    return {
      BelongCompanyTypeId: "", //所属单位
      Status: 9, // 9：停车场
      statusName: "停车场基础信息",
      loading: true,
      loadingText: "加载中...",
      searching: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      CompanyType: "停车场",
      companyName: "", //企业名称
      level: "", //等级
      typeOptions: [],
      typeLevelDic: [], //所属单位
      warehouselist: [],
      warehousevalue: "",
      selectData: null,
      dialogOpts: {
        dialogTableVisible: false,
        rowlist: null,
        dialogTable2Visible: false,
        rowlist2: null,
      },
      materialTypedate: null,
      materialTypedate2: null,
      MaterialTypeDic: [],
    };
  },
  components: {},
  created: function() {
    this.basedatabind();
  },
  mounted: function() {
    this.$nextTick(() => {
      this.search();
    });
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    //基础数据绑定 所属单位
    basedatabind() {
      this.loading = true;
      this.loadingText = "加载中...";
      utils
        .waitAll([this.config.getUValue("cyjc:cy", "")])
        .then((r) => {
          const eventlevelconf = r[0];
          this.typeOptions = eventlevelconf.JValue;
          for (let i = 0; i < this.typeOptions.length; i++) {
            let obj = {};
            let item = this.typeOptions[i];
            obj.ItemKey = item.ItemKey;
            obj.Extend1 = item.Extend1;
            this.typeLevelDic.push(obj);
          }
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
      this.dialogOpts.rowlist = val;
      this.dialogOpts.rowlist2 = val;
      this.materialTypedate = this.MaterialTypeDic;
      this.materialTypedate2 = this.MaterialTypeDic;
    },
    search() {
      let searchInfo = {
        Name: this.companyName,
        BelongTypeId: this.BelongCompanyTypeId,
        CompanyType: this.CompanyType,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
      };
      this.searching = true;
      new MyApis.TbTourCompanyApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          // r.PageContents.forEach(el=>{
          //   el.JsonExtend = JSON.parse(el.JsonExtend)
          // })
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.searching = false;
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.searching = false;
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },

    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    clearsearch() {
      this.companyName = "";
      this.level = "";
    },

    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/CompanyParkAdd",
        query: {
          CompanyType: this.CompanyType,
          status: this.Status,
          InfoId: row.ID,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/CompanyParkAdd",
        // name: 'mallList',
        query: {
          CompanyType: this.CompanyType,
          status: this.Status,
          InfoId: row.ID,
          type: "look",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/IndustrialMonitoring/UI/CompanyParkAdd",
        query: {
          CompanyType: this.CompanyType,
          InfoId: "",
          type: "add",
          status: this.Status,
        },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        new MyApis.TbTourCompanyApi()
          .DelItem(row)
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.logInfo.ActionName = this.CompanyType + "基础信息删除";
            this.logInfo.LogMessage = r
              ? this.CompanyType + "基础信息删除成功"
              : this.CompanyType + "基础信息删除失败";
            this.logInfo.ModuleName = "产业基础信息";
            this.logInfo.PageName = this.CompanyType + "基础信息";
            this.addOperationLog();
            this.loading = false;
            this.search();
          })
          .catch((e) => {
            this.errmsg(e.RspMsg ? e.RspMsg : "删除失败！");
            this.loading = false;
          });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
<style lang="css" scoped>
.table-default /deep/.el-table__body-wrapper {
  height: calc(100% - 44px) !important;
}
</style>
